import * as React from 'react';
import {Plugins} from '@packages/systems/wfdl';

export const usePlugins = (): Plugins.PluginsType => {
  return React.useContext(Plugins.RuntimeContext);
};
